module.exports = __webpack_public_path__ + "static/media/1_pl.02824a31.png";